import { ReactElement } from 'react';

function Header(): ReactElement {
  return (
    <>
      <text
        x={760}
        y={60}
        fontSize={8}
        fill='white'
        stroke='white'
        strokeWidth={0.2}
      >
        115KV POI
      </text>
    </>
  );
}

export default Header;
